import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgHeartIconSecondary from './svgs/HeartIconSecondary.js';
import SvgHeartIcon from './svgs/HeartIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var heartIcon = (props => useIcon(SvgHeartIcon, SvgHeartIconSecondary, props));

export { heartIcon as default };
